<template>
  <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      <v-layout class="px-4">
        <v-flex> Select Equipment </v-flex>
        <v-flex class="text-right">
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button"
            depressed
            icon
            :disabled="loading"
            v-on:click="$emit('close', true)"
            color="red white--text"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="px-4 w-100">
        <div class="d-flex mb-2">
          <v-text-field
            id="equipment-search"
            v-model="search"
            class="line-item-header-text px-0 v-slot-m-none"
            placeholder="Search Equipment..."
            dense
            filled
            solo
            flat
            color="cyan"
            :loading="loading"
            :disabled="loading"
            style="max-width: 400px"
          />
          <v-select
            v-model="selectedBrand"
            :items="brandOptions"
            item-text="text"
            item-value="text"
            label="Filter by Brand"
            clearable
            dense
            filled
            solo
            flat
            color="cyan"
            :loading="loading"
            :disabled="loading"
            style="max-width: 200px"
            class="ml-2"
          />
          <v-select
            v-model="selectedCategory"
            :items="categoryOptions"
            item-text="text"
            item-value="text"
            label="Filter by Category"
            clearable
            dense
            filled
            solo
            flat
            color="cyan"
            :loading="loading"
            :disabled="loading"
            style="max-width: 200px"
            class="ml-2"
          />
          <v-btn
            v-on:click="getEquipments()"
            :loading="loading"
            :disabled="loading"
            style="height: 32px !important"
            class="custom-bold-button ml-2"
            depressed
            color="cyan white--text"
            >Search</v-btn
          >
        </div>

        <div class="mb-2" v-if="selectedEquipments.length > 0">
          <strong>Selected Equipment ({{ selectedEquipments.length }}):</strong>
          <v-chip
            v-for="(equipment, index) in selectedEquipments"
            :key="`selected-${index}`"
            class="ma-1"
            close
            @click:close="removeEquipment(equipment)"
            color="cyan"
            text-color="white"
          >
            {{ equipment.name }} ({{ equipment.barcode }})
          </v-chip>
        </div>

        <div class="custom-border-top">
          <div class="custom-listing-table">
            <v-simple-table
              class="simple-table"
              v-if="list.length"
              style="width: 100%; table-layout: fixed"
            >
              <thead>
                <tr>
                  <th class="simple-table-th text-center" width="100">
                    <v-checkbox
                      v-model="selectAll"
                      :indeterminate="isIndeterminate"
                      hide-details
                      class="ma-0 pa-0 d-inline-flex align-center justify-center"
                      color="cyan"
                      @change="toggleSelectAll"
                    />
                  </th>
                  <th class="simple-table-th" width="200">Image</th>
                  <th class="simple-table-th" width="200">Barcode</th>
                  <th class="simple-table-th" width="200">Name</th>
                  <th class="simple-table-th" width="200">Serial No.</th>
                  <th class="simple-table-th">Brand/Category</th>
                </tr>
              </thead>
              <tbody class="custom-border-bottom custom-border-top">
                <tr
                  v-for="(item, index) in list.filter(
                    (i) => i.type === 'personal'
                  )"
                  :key="`equipment-${index}`"
                  class="alternate-listing-row"
                >
                  <td class="simple-table-td text-center">
                    <v-checkbox
                      :input-value="isSelected(item)"
                      @change="toggleItem(item)"
                      hide-details
                      class="ma-0 pa-0 d-inline-flex align-center justify-center"
                      color="cyan"
                    />
                  </td>
                  <td class="simple-table-td">
                    <template v-if="item.image">
                      <v-img
                        class="customer-image"
                        width="50"
                        height="50"
                        contain
                        :lazy-src="$defaultImage"
                        :src="item.image"
                      ></v-img>
                    </template>
                    <template v-else>
                      <v-img
                        class="customer-image"
                        width="50"
                        height="50"
                        contain
                        :lazy-src="$defaultImage"
                        :src="$defaultImage"
                      ></v-img>
                    </template>
                  </td>
                  <td class="simple-table-td">
                    <template v-if="item.barcode">
                      <Barcode :barcode="item.barcode" />
                    </template>
                    <em v-else class="text-muted"> no barcode </em>
                  </td>
                  <td class="simple-table-td text-capitalize">
                    <template v-if="item.name">
                      {{ item.name || item.name }}</template
                    >
                    <template v-else>
                      <em class="text-muted"> no name </em></template
                    >
                  </td>
                  <td class="simple-table-td">
                    <template v-if="item.serial_no">
                      <div>
                        <v-chip
                          color="chip-custom-blue"
                          label
                          small
                          outlined
                          class="mr-1"
                        >
                          {{ item.serial_no }}
                        </v-chip>
                      </div>
                    </template>
                    <em v-else class="text-muted"> no serial no </em>
                  </td>
                  <td class="simple-table-td">
                    <div class="warranty-listing-product">
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Brand: </b>

                        <template v-if="item.brand"> {{ item.brand }}</template>
                        <template v-else>
                          <em class="text-muted"> no brand </em></template
                        >
                      </p>
                      <p class="m-0 custom-nowrap-ellipsis">
                        <b>Category: </b>
                        <v-chip
                          outlined
                          text-color=""
                          label
                          small
                          color="blue"
                          v-if="item.category"
                        >
                          {{ item.category }}
                        </v-chip>
                        <template v-else
                          ><em class="text-muted">No Category</em></template
                        >
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div
              v-else
              class="d-flex justify-center align-center py-3 font-weight-500"
            >
              <img
                width="40px"
                :src="$assetURL('media/error/empty.png')"
                class="row-not-found-image mr-2"
              />
              Uhh... There are no equipment available at the moment.
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:action>
      <v-flex class="text-right">
        <v-btn
          v-on:click="saveSelection()"
          :disabled="selectedEquipments.length === 0"
          :loading="loading"
          class="custom-bold-button"
          depressed
          color="cyan white--text"
          >Assign Selected Equipment ({{ selectedEquipments.length }})</v-btn
        >
        <v-btn class="custom-bold-button mr-2" depressed @click="onCancel">
          Cancel
        </v-btn>
      </v-flex>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { QUERY } from "@/core/services/store/request.module";
import ObjectPath from "object-path";

export default {
  name: "select-equipment",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: Number,
      default: 0,
    },
    customerName: {
      type: String,
      default: "",
    },
    preSelectedEquipments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      search: null,
      list: [],
      selectedEquipments: [],
      selectedBrand: null,
      selectedCategory: null,
      brandOptions: [],
      categoryOptions: [],
      selectAll: false,
    };
  },
  watch: {
    dialog(param) {
      if (param) {
        this.search = null;
        this.selectedEquipments = [...this.preSelectedEquipments];
        this.selectedBrand = null;
        this.selectedCategory = null;
        this.selectAll = false;
        this.getEquipments();
      }
    },
    selectedBrand() {
      this.getEquipments();
    },
    selectedCategory() {
      this.getEquipments();
    },
    selectedEquipments() {
      if (this.selectedEquipments.length === 0) {
        this.selectAll = false;
      } else if (this.selectedEquipments.length === this.list.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    // list() {
    //   if (this.list.length > 0 && this.preSelectedEquipments.length > 0) {
    //     this.preSelectedEquipments.forEach((preSelected) => {
    //       const existsInList = this.list.find(
    //         (item) => item.id === preSelected.id
    //       );
    //       const existsInSelected = this.selectedEquipments.find(
    //         (item) => item.id === preSelected.id
    //       );

    //       if (existsInList && !existsInSelected) {
    //         this.selectedEquipments.push(preSelected);
    //       }
    //     });
    //   }
    //   this.$nextTick(() => {
    //     if (this.selectedEquipments.length === 0) {
    //       this.selectAll = false;
    //     } else if (this.selectedEquipments.length === this.list.length) {
    //       this.selectAll = true;
    //     } else {
    //       this.selectAll = false;
    //     }
    //   });
    // },
  },
  components: {
    Dialog,
    Barcode,
  },
  methods: {
    isSelected(item) {
      return this.selectedEquipments.some((e) => e.id === item.id);
    },

    toggleItem(item) {
      const index = this.selectedEquipments.findIndex((e) => e.id === item.id);

      if (index === -1) {
        this.selectedEquipments.push(item);
      } else {
        this.selectedEquipments.splice(index, 1);
      }
    },
    onCancel() {
      this.selectedEquipments = [...this.preSelectedEquipments];
      this.selectAll = false;
      this.$emit("close", true);
    },

    // toggleSelectAll(value) {
    //   if (value) {
    //     this.selectedEquipments = [...this.list];
    //   } else {
    //     this.selectedEquipments = [];
    //   }
    // },
    toggleSelectAll(value) {
      if (value) {
        const map = new Map(this.selectedEquipments.map((e) => [e.id, e]));
        this.list.forEach((item) => map.set(item.id, item));
        this.selectedEquipments = [...map.values()];
      } else {
        this.selectedEquipments = this.selectedEquipments.filter(
          (e) => !this.list.some((item) => item.id === e.id)
        );
      }
    },

    removeEquipment(equipment) {
      const index = this.selectedEquipments.findIndex(
        (item) => item.id === equipment.id
      );
      if (index > -1) {
        this.selectedEquipments.splice(index, 1);
      }
    },
    saveSelection() {
      this.$emit("equipment-selected", this.selectedEquipments);
      this.$emit("close", true);
    },
    getEquipments() {
      this.loading = true;
      this.list = [];

      const requestData = {
        activated: 1,
        search: this.search,
        is_checklist: 1,
      };

      if (this.selectedBrand) {
        requestData.brand = this.selectedBrand;
      }

      if (this.selectedCategory) {
        requestData.category = this.selectedCategory;
      }

      this.$store
        .dispatch(QUERY, {
          url: "equipment-list",
          data: requestData,
        })
        .then((response) => {
          this.list = ObjectPath.get(response, "data.equipment", []);
          this.brandOptions = ObjectPath.get(response, "data.brands", []);
          this.categoryOptions = ObjectPath.get(
            response,
            "data.categories",
            []
          );
        })
        .catch((error) => {
          console.error("API error:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 70);
    },
    isIndeterminate() {
      return (
        this.selectedEquipments.length > 0 &&
        this.selectedEquipments.length < this.list.length
      );
    },
  },
};
</script>
